import { Common } from './common';

export class SupplierResourceEventLog extends Common {
    public supplierRegionName: string;
}
